import React from "react";
import { FiChevronDown } from "react-icons/fi";
import { DropdownOption, DropdownProps } from ".";

export const Dropdown: React.FunctionComponent<DropdownProps> = ({
  selected,
  onChange,
  placeholder,
  options,
  error,
}) => (
  <div
    className={`dropdown border border-${error ? "danger" : "grey"} rounded`}
  >
    <button
      className="btn dropdown-toggle border-0 w-full justify-between flex"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      {selected ?? placeholder}
      <FiChevronDown className="ml-1 text-grey" size={24} />
    </button>
    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <div className="mt-1">
        {options?.map(({ value, label }: DropdownOption) => (
          <a
            key={value}
            className="dropdown-item"
            onClick={() => onChange({ value, label })}
          >
            {label}
          </a>
        ))}
      </div>
    </div>
  </div>
);
